export enum COHOFeedbackTypes
{
    FEEDBACK = 1,
    ANSWER = 2,
    SUGGESTION = 3
}
